module.exports = __webpack_public_path__ + "img/NetzTaliban.0132b411.png";